// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chips__item[data-v-7006dd4c] {
  background-color: rgba(50, 115, 220, 0.2);
  transition: 0.3s;
}
.chips__item[data-v-7006dd4c]:hover {
  background-color: rgba(50, 115, 220, 0.3);
}
.chips__itemInput[data-v-7006dd4c] {
  display: inline-block;
}
.chips__input--fake[data-v-7006dd4c] {
  border: none;
  width: 100%;
  line-height: 1.42857143;
  font-size: 1rem;
  height: 36px;
}
.chips__input--fake[data-v-7006dd4c]:focus, .chips__input--fake[data-v-7006dd4c]:active {
  outline: none;
}
.allitems__list[data-v-7006dd4c] {
  padding: 6px;
  transition: 0.3s;
}
.allitems__list[data-v-7006dd4c]:hover {
  background: #3273dc;
  color: #ffffff;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
